import { config, Navigate, React, Route, Routes, ts, ui, useSelector } from '_core';

import Layout from './layout';

const UsersLazy = React.lazy(() => import('./users'));
const PublishResourcesLazy = React.lazy(() => import('./publish-resources'));
const DashboardLazy = React.lazy(() => import('./dashboard'));
const DatasetsLazy = React.lazy(() => import('./datasets'));
const FinseraAdminLazy = React.lazy(() => import('./finsera-admin'));
const HelpLazy = React.lazy(() => import('./help'));
const ReleaseNotesLazy = React.lazy(() => import('./release-notes'));
const FinseraMcpLazy = React.lazy(() => import('./finsera-mcp'));
const ResourcesRouterLazy = React.lazy(() => import('./resources-router'));

const UsersDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <UsersLazy />
    </React.Suspense>
  );
};

const DashboardDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <DashboardLazy />
    </React.Suspense>
  );
};

const DatasetsDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <DatasetsLazy />
    </React.Suspense>
  );
};

const FinseraAdminDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <FinseraAdminLazy />
    </React.Suspense>
  );
};

const PublishResourcesDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <PublishResourcesLazy />
    </React.Suspense>
  );
};

const HelpDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <HelpLazy />
    </React.Suspense>
  );
};

const ReleaseNotesDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <ReleaseNotesLazy />
    </React.Suspense>
  );
};

const FinseraMcpDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <FinseraMcpLazy />
    </React.Suspense>
  );
};

const ResourcesRouterDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <ResourcesRouterLazy />
    </React.Suspense>
  );
};

const LoggedInRouter = () => {
  const org_id = useSelector((state: ts.StoreState) => state.auth.organization.id);

  return (
    <Layout>
      <ui.Websocket>
        <Routes>
          <Route path="/user-management">
            <Route index path="*" element={<UsersDeferred />} />
          </Route>

          <Route path="/dashboard">
            <Route index path="*" element={<DashboardDeferred />} />
          </Route>

          <Route path="/datasets">
            <Route index path="*" element={<DatasetsDeferred />} />
          </Route>

          <Route path="/help">
            <Route index path="*" element={<HelpDeferred />} />
          </Route>

          <Route path="/release-notes">
            <Route index path="*" element={<ReleaseNotesDeferred />} />
          </Route>

          {config.features.mcp_enabled && (
            <Route path="/finsera-mcp">
              <Route index path="*" element={<FinseraMcpDeferred />} />
            </Route>
          )}

          {config.features.publish_source && (
            <Route path="/publish">
              <Route index path="*" element={<PublishResourcesDeferred />} />
            </Route>
          )}

          {org_id == 0 && (
            <Route path="/finsera-admin">
              <Route index path="*" element={<FinseraAdminDeferred />} />
            </Route>
          )}

          {/* If we are on root, Navigate to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" />} />

          <Route path="/blank-loading" element={<ui.CenteredLoader />} />

          {/* If no route match, then go to workspace or jobber */}
          <Route path="*" element={<ResourcesRouterDeferred />} />
        </Routes>
      </ui.Websocket>
    </Layout>
  );
};

export default LoggedInRouter;
